import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';
import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, KeyboardEvent, Props } from './types';

import styles from './styles.module.scss';

const CollapsibleSection: FunctionComponent<Props> = ({
    children,
    className = '',
    isOpen,
    onToggle,
    testId = TEST_ID,
    title
}) => {
    const chevronOpenClass = isOpen ? styles.chevronOpen : '';

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
        }
    };

    return (
        <VerticalContainer className={`${className} ${styles.collapsibleSection}`} testId={testId}>
            <div
                aria-expanded={isOpen}
                className={styles.headerWrapper}
                onClick={onToggle}
                onKeyDown={handleKeyDown}
                role='button'
                tabIndex={0}>
                <HorizontalContainer className={styles.header}>
                    <LabelText className={styles.title} text={title} />

                    <span className={`${chevronOpenClass} ${styles.chevron}`}>
                        <TriangleArrowIcon />
                    </span>
                </HorizontalContainer>
            </div>

            {isOpen && <VerticalContainer className={styles.body}>{children}</VerticalContainer>}
        </VerticalContainer>
    );
};

export default CollapsibleSection;
